//import 'bootstrap/dist/css/bootstrap.min.css';
import '@/scss/bootstrap.scss';
//import 'bootstrap/scss/bootstrap';
import '@/assets/css/style.css';
import '@/main.scss';

import { createApp } from 'vue';
import store from '@/store';
import App from '@/App.vue';
import router from '@/router';
import axios from 'axios';
import { createMetaManager } from 'vue-meta';
import { FontAwesomeIcon } from '@/assets/plugins/font-awesome';
import device from '@/assets/plugins/vue3-device-detector';
import { vfmPlugin } from 'vue-final-modal';
import app_mixin from "@/mixin";
import lib from '@/lib';

import 'bootstrap';

import Prism from 'prismjs'
import "prismjs/themes/prism-okaidia.css";
import 'prismjs/components/prism-markup-templating';
import 'prismjs/components/prism-php';
import 'prismjs/components/prism-twig';
import 'prismjs/components/prism-json';
import 'prismjs/components/prism-sql';
import 'prismjs/components/prism-yaml';
import 'prismjs/components/prism-python';

import { Tooltip } from 'bootstrap';
new Tooltip(document.body, {
	selector: "[data-bs-toggle='tooltip']",
});

const app = createApp(App);
const metaManager = createMetaManager();

window['appInstance'] = null;
window['appComponent'] = null;
window['storeInstance'] = null;

app.config.globalProperties.$axios = axios;
app.config.globalProperties.$store = store;
app.use(router);
app.use(store);
app.use(metaManager);
app.use(device);
app.use(vfmPlugin);

// Создаем глобальную директиву v-highlight
app.directive('highlight', {
	mounted(el) {
		el.querySelectorAll('pre code').forEach((block) => {
			Prism.highlightElement(block)
		});
	},
	updated(el) {
		el.querySelectorAll('pre code').forEach((block) => {
			Prism.highlightElement(block)
		});
	},
});

app.component('font-awesome-icon', FontAwesomeIcon);
lib.addMixin(app_mixin);
app.mount('#app');

window['lib'] = lib;
window['axios'] = axios;

window['appInstance'] = app;
window['storeInstance'] = store;

// Автопродление токена в случае необходимости
axios.interceptors.response.use(
	response => response,
	async error => {
		const originalRequest = error.config;
		
		// Проверка отсутствия токена, чтобы исключить повторную попытку
		if (!originalRequest.headers['Authorization'] || originalRequest._retry) {
			return Promise.reject(error);
		}
		
		if (error.response.status === 401) {
			originalRequest._retry = true; // Установка флага для предотвращения повторных попыток
			
			try {
				// Проверка черного списка токенов перед обновлением
				const token = originalRequest.headers['Authorization'].split(' ')[1];
				const isBlacklisted = await store.state.app.auth.doCheckTokenBlacklist(token);
				if (isBlacklisted) {
					store.state.app.auth.doLogout();
					return Promise.reject(error);
				}
				
				// Проверка наличия сессии
				const isSessionValid = await store.state.app.auth.doCheckSession();
				if (!isSessionValid) {
					store.state.app.auth.doLogout();
					return Promise.reject(error);
				}
				
				const newToken = await store.state.app.auth.doRefreshToken();
				axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
				originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
				if (newToken) {
					axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
					originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
					
					// ПОВТОРНО выполняем запрос с новым токеном
					return axios(originalRequest);
				} else {
					throw new Error('Failed to refresh token');
				}
			} catch (refreshError) {
				// Обработка ошибки обновления токена
				console.error('Ошибка обновления токена', refreshError);
				
				if (refreshError.response && refreshError.response.status === 401) {
					store.state.app.auth.doLogout();
				}
				
				return Promise.reject(refreshError);
			}
		}
		return Promise.reject(error);
	}
);
